interface StatusBadgeProps {
  status: string
}

const statusConfig: Record<string, { label: string; bg: string; color: string }> = {
  online: { label: 'Online', bg: '#d1fae5', color: '#065f46' },
  offline: { label: 'Offline', bg: '#fee2e2', color: '#991b1b' },
  updating: { label: 'Updating', bg: '#fef3c7', color: '#92400e' },
  config_pending: { label: 'Config Pending', bg: '#dbeafe', color: '#1e40af' },
  pending_approval: { label: 'Pending Approval', bg: '#fef3c7', color: '#92400e' },
  disabled: { label: 'Disabled', bg: '#f3f4f6', color: '#4b5563' },
  unknown: { label: 'Unknown', bg: '#f3f4f6', color: '#374151' },
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const cfg = statusConfig[status] ?? statusConfig.unknown

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 9999,
        fontSize: 12,
        fontWeight: 600,
        background: cfg.bg,
        color: cfg.color,
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
      }}
    >
      {cfg.label}
    </span>
  )
}
